import React from 'react'
import styles from './EventPage.module.css'
import UpcomingEvents from '../../sections/UpcomingEvents/UpcomingEvents'
import EventSection from '../../sections/EventSection/EventSection'
import SuccessSection from '../../sections/SuccessSection/SuccessSection'
import FoodGalleryCarousell from '../../sections/FoodGalleryCarousell/FoodGalleryCarousell'
import ReservationSection from '../../sections/ReservationSection/ReservationSection'
import CateringSection from '../../sections/CateringSection/CateringSection'

const EventPage = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.eventInner}>
                <img src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/test1.png"} alt="" />
            </div>

            <UpcomingEvents />
            <EventSection />
            <CateringSection />
            <SuccessSection />
            <FoodGalleryCarousell />
            <ReservationSection/>
        </div>
    )
}

export default EventPage